module.exports = __webpack_public_path__ + "static/media/imageIcon.60308150.svg";